import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { Browser, Dropzone } from '@atlaskit/media-picker';
import { fg } from '@atlaskit/platform-feature-flags';
var AttachmentsUpload = function AttachmentsUpload(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isBrowserOpen = _useState2[0],
    setIsBrowserOpen = _useState2[1];
  var dropzoneContainer = props.dropzoneContainer,
    onUploadStart = props.onUploadStart,
    onUploadError = props.onUploadError,
    mediaClientConfig = props.mediaClientConfig,
    uploadConfig = props.uploadConfig,
    onUploadEnd = props.onUploadEnd,
    onDragEnter = props.onDragEnter,
    onDragLeave = props.onDragLeave,
    renderPropFn = props.children;
  var browserConfig = _objectSpread(_objectSpread({}, uploadConfig), {}, {
    multiple: true
  });
  var dropzoneConfig = _objectSpread({}, uploadConfig);
  if (dropzoneContainer) {
    dropzoneConfig.container = dropzoneContainer;
  }

  // this is incremented whenever the mediaClientConfig and onUploadStart changes which in turn changes the key of the Browser component to trigger a remount
  // this is because the Browser component does not update its mediaClient on re-render, only remounts
  // TODO: REQIN-1937 try to fix the underlying issue in authProvider to remove this useEffect
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    mediaConfigRefreshCount = _useState4[0],
    setMediaConfigRefreshCount = _useState4[1];
  useEffect(function () {
    setMediaConfigRefreshCount(mediaConfigRefreshCount + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mediaClientConfig]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, fg('forms-bugfix-google-translate-attachment-field') ? /*#__PURE__*/React.createElement("div", {
    translate: "no"
  }, /*#__PURE__*/React.createElement(Browser, {
    isOpen: isBrowserOpen,
    config: browserConfig,
    mediaClientConfig: mediaClientConfig,
    onUploadsStart: onUploadStart,
    onError: onUploadError,
    onEnd: onUploadEnd,
    onClose: function onClose() {
      return setIsBrowserOpen(false);
    },
    key: String(mediaConfigRefreshCount)
  }), /*#__PURE__*/React.createElement(Dropzone, {
    mediaClientConfig: mediaClientConfig,
    config: dropzoneConfig,
    onUploadsStart: onUploadStart,
    onEnd: onUploadEnd,
    onDragEnter: onDragEnter,
    onDragLeave: onDragLeave
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Browser, {
    isOpen: isBrowserOpen,
    config: browserConfig,
    mediaClientConfig: mediaClientConfig,
    onUploadsStart: onUploadStart,
    onError: onUploadError,
    onEnd: onUploadEnd,
    onClose: function onClose() {
      return setIsBrowserOpen(false);
    },
    key: String(mediaConfigRefreshCount)
  }), /*#__PURE__*/React.createElement(Dropzone, {
    mediaClientConfig: mediaClientConfig,
    config: dropzoneConfig,
    onUploadsStart: onUploadStart,
    onEnd: onUploadEnd,
    onDragEnter: onDragEnter,
    onDragLeave: onDragLeave
  })), renderPropFn({
    setIsBrowserOpen: setIsBrowserOpen
  }));
};
export default AttachmentsUpload;